export const LOG_IN = 'LOG_IN'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'

export const SIGN_UP = 'SIGN_UP'
export const SIGN_UP_SUCCESS = 'SIGN_UP_ACCESS'
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR'

export const LOG_OUT = 'LOG_OUT'

// ---------------------------------- LOG IN ------------------------------------

/**
 * Log In
 * @param {*} email 
 * @param {*} password 
 */
export function authLogIn(email, password) {
  return (dispatch) => {
    dispatch(logIn())
    // @TODO Fetch the log in API, call Sign In success or failure
  }
}


function logIn() {
  return {
    type: LOG_IN
  }
}

function logInSuccess(user) {
  return {
    type: LOG_IN_SUCCESS,
    user: user
  }
}

// ------------------------------------ SIGN UP -----------------------------------------

/**
 * Sign Up User
 * @param {*} email 
 * @param {*} password 
 * @param {*} firstName 
 * @param {*} lastName 
 * @param {*} phone 
 */
export function authSignUp(email, password, firstName, lastName, phone) {
  return (dispatch) => {
    dispatch(signUp())
    // @TODO Fetch the sign up API, call sign Up success or failure
    return fetch('/api/createUser', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        first_name: firstName,
        last_name: lastName,
        email: email,
        password: password,
        phone: phone,
      })
    })
    .then((res) => res.json())
    .then((user) => {
      console.log(user);
      if (user.code) {
        // Error
        console.log(user.code);
        dispatch(signUpError());
      }
      else {
        dispatch(signUpSuccess(user[0]));
      }
    })
  }
}

function signUp() {
  return {
    type: SIGN_UP
  }
}

function signUpSuccess(user) {
  return {
    type: SIGN_UP_SUCCESS,
    user: user
  }
}

function signUpError() {
  return {
    type: SIGN_UP_ERROR
  }
}

// ----------------------------------------- LOG OUT --------------------------------------------

/**
 * Log Out User
 */
export function logOut() {
  return (dispatch) => {
    dispatch(removeCredentials())
  }
}

function removeCredentials() {
  return {
    type: LOG_OUT
  }
}
